import React, { useState } from "react";
import { Lock02 } from "@untitledui/icons/Lock02";
import { Check } from "@untitledui/icons/Check";
import Input from "../components/Input";
import Button from "../components/Buttons/button";
import { ArrowNarrowLeft } from "@untitledui/icons/ArrowNarrowLeft";
import { closeModal, openModals } from "../redux/modal.slice";
import ModalsEnum from "../enums/modal.enum";
import { useDispatch } from "react-redux";
import { changePassword_req } from "../api/profiles.api";
import { useLocation, useNavigate } from "react-router-dom";

import * as yup from "yup";
import { Formik } from "formik";

const SetNewPassword = () => {
  const location = useLocation();
  const navigation = useNavigate();

  const dispatch = useDispatch();
  const [completed, setCompleted] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const confirmationToken = queryParams.get("reset_password_token");
  const signUpScheme = yup.object().shape({
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must have at least one uppercase letter")
      .matches(/[a-z]/, "Password must have at least one lowercase letter")
      .matches(/\d/, "Password must have at least one digit")
      .matches(
        /[@$!%*?&_.]/,
        "Password must have at least one special symbol (@, $, !, %, *, ?, &, _, .)"
      )
      .required("Password is required"),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password"), undefined], "Passwords must match")
      .required("Confirm password is required"),
  });
  const backToLogin = () => {
    dispatch(closeModal({}));

    dispatch(
      openModals({
        modalIds: [ModalsEnum.SIGN_IN_MODAL],
      })
    );
  };

  const changePasswordReq = async (data) => {
    try {
      const response = await changePassword_req(data, confirmationToken);
      if (response) {
        setCompleted(!completed);
      }
    } catch (e) {
      console.log("e", e);
    }
  };
  const goHome = () => {
    navigation("/");
  };

  return (
    <div className="set-new-password text-center">
      <div className="container">
        {!completed ? (
          <>
            <div className="icon purple mb-24">
              <Lock02
                size={24}
                color={"#9E77ED"}
              />
            </div>
            <h3 className="mb-12">Set New Password</h3>
            <p className="medium-text text-color-grey mb-32">
              Choose a new password — make sure it’s secure and easy to
              remember.
            </p>
            <Formik
              initialValues={{
                password: "",
                password_confirmation: "",
              }}
              validateOnMount={true}
              onSubmit={(values) => changePasswordReq(values)}
              validationSchema={signUpScheme}
            >
              {({ handleChange, handleSubmit, values, touched, errors }) => {
                return (
                  <>
                    <Input
                      id={"password"}
                      label={"Password"}
                      placeholder={"Enter new password"}
                      name={"password"}
                      type={"password"}
                      onChange={handleChange}
                      className="mb-24"
                      errorMessage={
                        touched?.password && errors?.password && errors.password
                      }
                    />
                    <Input
                      id={"confirm-password"}
                      label={"Confirm Password"}
                      placeholder={"Confirm new password"}
                      name={"password_confirmation"}
                      type={"password"}
                      onChange={handleChange}
                      className="mb-24"
                      errorMessage={
                        touched?.password_confirmation &&
                        errors?.password_confirmation &&
                        errors.password_confirmation
                      }
                    />
                    <Button
                      text={"Reset Password"}
                      fullWidth={true}
                      onClick={handleSubmit}
                    />
                  </>
                );
              }}
            </Formik>

            <div className="flex flex-justify-center pt-24">
              <button
                className="back-login-button flex flex-align-center flex-justify-center text-color-grey"
                onClick={backToLogin}
              >
                <ArrowNarrowLeft
                  color={"#475467"}
                  className={"mr-8"}
                />
                <strong>Back to Log In</strong>
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="icon purple mb-24">
              <Check
                size={24}
                color={"#9E77ED"}
              />
            </div>
            <h3 className="mb-12">Password Reset</h3>
            <p className="medium-text text-color-grey mb-32">
              Your password has been successfully reset. Click below to log in
            </p>
            <Button
              text={"Continue"}
              fullWidth={true}
              onClick={goHome}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SetNewPassword;
